import requester from '@/lib/axios';
import { CourseFormatEnum } from '@/models/Course';
import CourseLessonPlan from '@/models/CourseLessonPlan';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

const BASE_URL = 'course-lesson-plans';

export type ListCourseLessonPlanFilters = BaseFilters & {
  coursePathId?: number[];
  courseId?: number[];
  formats?: CourseFormatEnum[];
};

export const listCourseLessonPlans = async (
  filters: ListCourseLessonPlanFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<CourseLessonPlan>>(
    `${BASE_URL}/`,
    { params: filters },
  );
  return data;
};

export const createCourseLessonPlan = async (
  body: Partial<CourseLessonPlan>,
) => {
  const { data } = await requester().post<CourseLessonPlan>(
    `${BASE_URL}/`,
    body,
  );
  return data;
};

export const removeCourseLessonPlan = async (lessonPlanId: number) => {
  await requester().delete<void>(`${BASE_URL}/${lessonPlanId}/`);
};
